import { AuthorizationsApiBase } from './paymentApi';

class AuthorizationApi extends AuthorizationsApiBase {

}

export default new AuthorizationApi();
